import OrderDTO from "@/dto/order/OrderDTO";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { observer } from "mobx-react-lite";
import React from "react";

interface RetailerShopTokenExpiredInfoProps {
    order: OrderDTO;
}

const RetailerShopTokenExpiredInfo: React.FC<RetailerShopTokenExpiredInfoProps> = function (props) {
    const { order } = props;

    const { supplierPartnershipsStore } = useOrderManagementStore();

    const info = order.supplierDropShippingInfo;

    if (!info) return null;

    if (supplierPartnershipsStore.supplierPartnershipsLoadingMap.get(order.shopId)) return null;

    const retailerShopId = info.retailerShopId;

    const partnership = supplierPartnershipsStore.retailerPartnershipMap.get(retailerShopId);

    if (!partnership) {
        return (
            <div className="text-error">
                该代理商店铺已注销发货易，无法查看地址和打印发货，可取消该订单
                <a
                    href="https://qw15p3s8hv.feishu.cn/wiki/E0HmwYXJmix3G3khXHJcYv4Onpf?from=from_copylink"
                    target="_blank"
                    className="ml5"
                >
                    查看取消订单教程
                </a>
            </div>
        );
    }

    const shopName = partnership?.alias || partnership?.name;

    return (
        <div className="text-error">
            代理商店铺【{shopName}】授权过期，无法查看地址，请联系代理商登录发货易，您再刷新页面即可
        </div>
    );
};

export default observer(RetailerShopTokenExpiredInfo);
